// Homepage themes (Me → Edit profile → Appearance). Only the page background and the
// text that sits directly on it change; cards, Pulse and navigation keep their own
// opaque surfaces so they stay readable on every theme.
import type { HomeTheme } from '../domain/types';
import { C } from './tokens';

export interface HomeThemeDef {
  id: HomeTheme;
  label: string;
  bg: string;
  /** Background as "r, g, b" for the veil over a custom image. */
  rgb: string;
  fg: string;
  muted: string;
  accent: string;
  dark: boolean;
}

export const HOME_THEME_DEFS: HomeThemeDef[] = [
  { id: 'white', label: 'Default White', bg: '#F7F7F9', rgb: '247, 247, 249', fg: C.ink, muted: C.grey, accent: C.violet, dark: false },
  { id: 'grey', label: 'Soft Grey', bg: '#E6E6EB', rgb: '230, 230, 235', fg: C.ink, muted: '#55555F', accent: C.violet, dark: false },
  { id: 'lavender', label: 'Lavender', bg: '#ECE8FD', rgb: '236, 232, 253', fg: C.ink, muted: '#56516B', accent: '#4B39C9', dark: false },
  { id: 'charcoal', label: 'Charcoal', bg: '#1B1B21', rgb: '27, 27, 33', fg: '#FFFFFF', muted: '#B4B4C0', accent: '#C2B4FF', dark: true },
];

export const homeTheme = (id?: string): HomeThemeDef => HOME_THEME_DEFS.find((t) => t.id === id) ?? HOME_THEME_DEFS[0];
